<template>
  <Category cate-name="life" category-name="生活" />
</template>

<script>
import Category from '@/components/Category.vue'
export default {
  components: {
    Category
  }
}
</script>

<style scoped></style>
